import { createReducer } from '@reduxjs/toolkit'
import { isEqual } from 'lodash'

import types from './types'

export { default as actions } from './actions'

export default createReducer(
  {},
  {
    [types.FETCH_COUNTS_SUCCESS]: (state, action) => {
      if (!isEqual(state, action.payload)) {
        return action.payload
      }
    },
  },
)
